<carousel class="carousel-component"
          [class.is-empty]="!component?.slides.length"
          [loop]="component?.loop"
          [autoplay]="component?.autoplay ? { delay: component?.interval} : false"
          [pagination]="component?.pagination"
          [navigation]="((component?.slides.length || 0) > 1 && component?.arrows) ? {
                            nextEl: '.carousel-next-' + uid,
                            prevEl: '.carousel-prev-' + uid
                        } : false"
          [scrollbar]="component?.progress"
          #carouselRef>
    @for (slide of component?.slides; track slide; let i = $index) {
    <ng-template swiperSlide>
        <div [ngClass]="[((!slide.custom && component.ratio) ? component.ratio : '')]">
            @if (!slide.custom) {
            <!-- image -->
            <img class="rf"
                 [image]="slide.image">
            }
            @if (slide.custom) {
            <icms-outlet [components]=" slide.components">
            </icms-outlet>
            }
        </div>
    </ng-template>
    }

    <!-- navigation -->
    @if (component?.slides.length > 1 && component?.arrows) {
    <div slot="container-start">
        <button class="pos-absolute top-50 left-4 z-5"
                [ngClass]="'carousel-prev-' + uid"
                type="button"
                aria-label="Previous slide">
            <i class="icon-chevron-left fs-6"
               aria-hidden="true"></i>
        </button>
        <button class="pos-absolute top-50 right-4 z-5"
                [ngClass]="'carousel-next-' + uid"
                type="button"
                aria-label="Next slide">
            <i class="icon-chevron-right fs-6"
               aria-hidden="true"></i>
        </button>
    </div>
    }
</carousel>
